export const STATUS_OPTIONS = [
  {
    label: 'Todos',
    value: '',
  },
  {
    label: 'Ativo',
    value: 'ACTIVE',
  },
  {
    label: 'Inativo',
    value: 'INACTIVE',
  },
]
